import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "font-14"
};
var _hoisted_2 = {
  class: "blue-color"
};
import { toRefs } from 'vue';
import { useRouter } from 'vue-router';
import { ChevronRightDoubleIcon } from 'tdesign-icons-vue-next';
import { storeToRefs } from 'pinia';
import useUserStore from '@/stores/modules/user';
import { MessagePlugin } from 'tdesign-vue-next';
/* api */
import { getAppAlias } from '@/api/home';
export default {
  __name: 'empty',
  props: {
    type: {
      //动态内容类型：活动0，相册1，课堂展示2，笔记3
      type: Number,
      default: 0
    },
    visitorType: {
      // 个人视角(我自己)0，游客视角1(自己访问自己空间仍为个人视角)
      type: Number,
      default: 0
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var router = useRouter();
    var _toRefs = toRefs(props),
      type = _toRefs.type;
    // console.log(type, '---type')
    var emptyData = [{
      title: '暂无活动',
      location: '活动广场',
      behavior: '参与活动',
      alias: 'activity',
      name: '活动'
    }, {
      title: '暂无内容',
      location: '班级相册',
      behavior: '收藏至个人相册',
      alias: ''
    }, {
      title: '暂无课堂展示内容',
      behavior: '在课堂上更积极地参与课堂互动吧~',
      alias: ''
    }, {
      title: '暂无内容',
      location: '笔记',
      behavior: '记下你的灵感',
      alias: 'cloudNotes',
      name: '云笔记'
    }];
    var _storeToRefs = storeToRefs(useUserStore()),
      token = _storeToRefs.token;
    var navigateTo = function navigateTo(item) {
      getAppAlias(item.alias).then(function (res) {
        if (res.data.code === 0) {
          if (res.data.data.result === 'access' && res.data.data.userStatus === 0 && res.data.data.memberStatus === 0) {
            if (item.alias === 'activity') {
              router.push({
                path: '/activity'
              });
            }
          } else {
            MessagePlugin.warning('抱歉，您暂无权限访问');
          }
        }
      });
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["empty-box", {
          'mar-b': _unref(type) === 3
        }])
      }, [_createElementVNode("div", null, _toDisplayString(emptyData[_unref(type)].title), 1), __props.visitorType === 1 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_unref(type) === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(emptyData[_unref(type)].behavior), 1)) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "font-14",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return navigateTo(emptyData[_unref(type)]);
        })
      }, [_cache[1] || (_cache[1] = _createTextVNode(" 点击前往-", -1)), _createElementVNode("span", _hoisted_2, _toDisplayString(emptyData[_unref(type)].location), 1), _createTextVNode("-" + _toDisplayString(emptyData[_unref(type)].behavior) + " ", 1), _createVNode(_unref(ChevronRightDoubleIcon), {
        class: "right-icon"
      })]))], 64)) : _createCommentVNode("", true)], 2);
    };
  }
};